<template>
  <div class="lesson-preview">
    <!-- Название урока -->
    <AppTitle mode="h4" class="lesson-preview__title">
      <template v-slot:title>{{ lesson.eventName }}</template>
    </AppTitle>

    <div class="lesson-preview__content">
      <div class="lesson-preview__subtitle">

        <!-- 1. ЗОНА ПЛЕЕРА / КАРТИНКИ (ИСПРАВЛЕНО) -->
        <div class="lesson-preview__video-block">
          <div class="image-wrapper">
            <img
              :src="`https://navigator.eurekacenter.ru/video/${lesson.videoFile.posterName}`"
              alt="Placeholder Image"
              class="responsive-image"
            />
            <button @click="$emit('selectVideo', lesson.videoFile)" class="overlay-button">
              {{ t("play") }}
            </button>
          </div>
        </div>

        <!-- 2. ЗОНА СПОЙЛЕРА ОПИСАНИЯ (ИСПРАВЛЕНО: вынесено в отдельный блок) -->
        <div class="lesson-preview__details-block" v-if="lesson.eventTypeId === 2 && lesson.eventDescription && lesson.eventDescription.length > 0">
          <v-expansion-panels>
            <v-expansion-panel title="О видео">
              <v-expansion-panel-text>
                <div class="ma-2 minimal-list" v-html="lesson.eventDescription"></div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <!-- Дата урока -->
        <MetaData :data="{ date: lesson.eventDateTime }" class="lesson-preview__meta" />
      </div>

      <!-- Кнопки действий (Вебинары / Записи) -->
      <AppButton
        v-if="lesson.eventTypeId === 1 && lesson.webinar && lesson.webinar.webinarStatus === 1"
        @click="$emit('beginWebinar', lesson.webinar)"
        class="lesson-preview__button"
      >
        <span>{{ t("join") }}</span>
      </AppButton>

      <AppButton
        v-else-if="lesson.eventTypeId === 1 && lesson.webinar && lesson.webinar.webinarStatus === 2 && lesson.webinar.recordStatus === 1 && lesson.webinar.webinarRecordUrl !== null"
        @click="$emit('startWebinar', lesson.webinar)"
        class="lesson-preview__button"
      >
        <span>{{ t("play") }}</span>
      </AppButton>
    </div>
  </div>
</template>

<script>
import MetaData from "@/components/MetaData";
import AppTitle from "@/elements/AppTitle.vue";
import { t } from "@/utils/translate";
import AppButton from "@/elements/AppButton.vue";

export default {
  components: { AppTitle, AppButton, MetaData },

  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },

  emits: ["beginWebinar", "startWebinar", "selectVideo"],
  setup() {
    return {
      t,
    };
  },
};
</script>

<style lang="scss">


    .lesson-preview {
      display: flex;
      flex-direction: column;
      width: 100% !important;
      min-width: 0 !important;

      &__title {
        margin-bottom: 20px;
        font-size: 22px;
        line-height: 1.3;
      }

      // Контентый контейнер
      &__content {
        display: flex;
        flex-direction: column; // ДЕФОЛТ ДЛЯ МОБИЛОК: Всё выстраивается вертикально!
        gap: 24px;
        width: 100% !important;
      }

      &__subtitle {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100% !important;
      }

      // --- БЛОК ВИДЕОПЛЕЕРА / ПОСТЕРА (ИСПРАВЛЕНО) ---
      &__video-block {
        width: 100% !important;
        display: block !important;
        position: relative;

        .image-wrapper {
          position: relative;
          width: 100% !important;
          display: block;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          aspect-ratio: 16 / 9 !important; // Гарантирует идеальные пропорции плеера
        }

        .responsive-image {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important; // Картинка заполняет весь плеер без искажений
          display: block;
        }

        // Красивая кнопка "Посмотреть" по центру видео
        .overlay-button {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: #f77587; // Ваш фирменный розовый цвет
          color: #ffffff;
          border: none;
          padding: 12px 28px;
          font-size: 15px;
          font-weight: 700;
          border-radius: 30px;
          cursor: pointer;
          box-shadow: 0 4px 14px rgba(247, 117, 135, 0.4);
          transition: all 0.2s ease;
          z-index: 2;

          &:hover {
            transform: translate(-50%, -50%) scale(1.05);
            background-color: darke(#f77587, 5%);
          }
        }
      }

      // Блок спойлера Vuetify
      &__details-block {
        width: 100% !important;
        margin-top: 4px;

        :deep(.v-expansion-panel) {
          border-radius: 8px !important;
          background-color: #f8fafc !important; // Легкий фон
        }
      }

      &__meta {
        margin-top: 8px;
      }

      &__button {
        width: 100% !important; // На мобилках кнопка растягивается во всю ширь для удобства тапа
        min-height: 46px;
      }

      // =========================================================================
      // ПК-ВЕРСИЯ: На экранах от 768px возвращаем привычный многоколоночный вид
      // =========================================================================
      @media (min-width: 768px) {
        &__content {
          flex-direction: row; // Возвращаем колонки бок о бок
          align-items: flex-start;
        }

        &__subtitle {
          flex-grow: 1;
        }

        &__video-block {
          max-width: 650px; // Ограничиваем максимальную ширину плеера на мониторах
        }

        &__button {
          width: max-content !important; // Кнопка возвращает свой компактный размер
        }
      }
    }

</style>
